<div class="d-flex flex-row flex-auto influencer-overview-report-container" *ngIf="!haveNoData">
  <div class="influencer-summarize-block">
    <div class="influencer-summarize-header header">
      <span>{{'measure.influencers' | translate}}</span>
    </div>
    <influencer-summarize [influencer]="segmentInfluencerOverview.influencers"></influencer-summarize>
  </div>
  <div class="nationality-block" *ngIf="nationalityCircleChartData">
    <div class="nationality-header header">
      <span>{{'measure.nationality' | translate}}</span>
    </div>
    <div class="d-flex chart-left-seperation">
      <div class="infl-overview-seperate-line"></div>
    </div>
    <achoo-pie-chart [chartData]="nationalityCircleChartData"
                     [chartTitle]=""
                     [height]="180"
                     [pieSize]="'105%'"
                     [pieInnerSize]="'87%'"
                     [pieCenter]="getPieCenter()"
                     [titleStyling]="{fontSize: '1rem'}"
                     [isUseInInfluencerOverviewReport]="true"
                     [legend]="{x: -24, y: 4, itemMarginBottom: 5, useHTML: true}"
                     [chartConfig]="{spacingTop: 12, spacingLeft: -10}">
    </achoo-pie-chart>
    <div class="d-flex chart-right-seperation">
      <div class="infl-overview-seperate-line"></div>
    </div>
  </div>
  <div class="platforms-block" *ngIf="platformLineChartData">
    <div class="platforms-header header">
      <span>{{'measure.platforms' | translate}}</span>
    </div>
    <achoo-column-chart [chartData]="platformLineChartData"
                        [chartTitle]=""
                        [chartCustomConfig]="{fontSize: 8, marginBottom: 80, pointWidth: 12}"
                        [height]="180">
    </achoo-column-chart>
  </div>
</div>
<div
  *ngIf="haveNoData"
  class="message">
  <span>{{'measure.noData' | translate}}</span>
</div>




// WEBPACK FOOTER //
// ./src/app/main/measure/influencer-overview-report/influencer-overview-report.component.html